import {Pipe, PipeTransform} from "@angular/core";
import {Role} from "../../model/role";

@Pipe({name: 'role'})
export class RolePipe implements PipeTransform {
    transform(value: any) {
        return Role[value];
    }
}
